export default "__VITE_ASSET__DbQx4NCL__"